import React from 'react';
import { Link } from 'react-router-dom';
import images from '../../assets';
import './Footer.scss';
import { contactDetails } from '../../utils/contact';

function Footer() {
    const iconStyle = {
        color: 'lightgray',
        size: '18',
    };
    return (
        <footer>
            <div className="footer-container">
                <div className="footer-col">
                    <div className="footer-img">
                        <img
                            src={images?.logoWhiteeRound}
                            alt="topnotch"
                            width="250"
                        />
                    </div>
                </div>
                <div className="footer-col">
                    <h3>Useful Links</h3>
                    <ul>
                        <Link className="footer-link" to={'/'}>
                            Home
                        </Link>
                        <Link className="footer-link" to={'/services'}>
                            Services
                        </Link>
                        <Link className="footer-link" to={'/projects'}>
                            Projects
                        </Link>
                        <Link className="footer-link" to={'/about'}>
                            About
                        </Link>
                    </ul>
                </div>
                <div className="footer-col">
                    <h3>Contact us</h3>
                    <ul>
                        <div className="contact-item">
                            <div className="contact-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 384 512"
                                    width={iconStyle?.size}
                                    height={iconStyle?.size}
                                    fill={iconStyle?.color}
                                >
                                    <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 256c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" />
                                </svg>
                            </div>
                            <span>{contactDetails.address}</span>
                        </div>
                        <div className="contact-item">
                            <div className="contact-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    width={iconStyle?.size}
                                    height={iconStyle?.size}
                                    fill={iconStyle?.color}
                                >
                                    <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
                                </svg>
                            </div>
                            <span>
                                <a href={`tel:${contactDetails.phone}`}>
                                    {contactDetails.phone}
                                </a>
                            </span>
                        </div>
                        <div className="contact-item">
                            <div className="contact-icon">
                                <svg
                                    viewBox="0 0 12 12"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={iconStyle?.size}
                                    height={iconStyle?.size}
                                    fill={iconStyle?.color}
                                >
                                    <g>
                                        <rect
                                            height="3"
                                            width="7"
                                            x="2.5"
                                            y="8.5"
                                        />
                                        <polygon points="10,3 10,0.5 3.5,0.5 2,2 2,3  " />
                                        <path d="M10.5,4h-9C0.6728516,4,0,4.6728516,0,5.5V10h1.5V7.5h9V10H12V5.5C12,4.6728516,11.3271484,4,10.5,4z    M10,6.5H9v-1h1V6.5z" />
                                    </g>
                                </svg>
                            </div>
                            <span>
                                <a href={`tel:${contactDetails.fax}`}>
                                    {contactDetails.fax}
                                </a>
                            </span>
                        </div>
                        <div className="contact-item">
                            <div className="contact-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    width={iconStyle?.size}
                                    height={iconStyle?.size}
                                    fill={iconStyle?.color}
                                >
                                    <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
                                </svg>
                            </div>
                            <span>
                                <a href={`mailto:${contactDetails.email}`}>
                                    {contactDetails.email}
                                </a>
                            </span>
                        </div>
                    </ul>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
